/* eslint-disable react/prop-types */
import PrivateImage from 'Modules/PrivateImage/PrivateImage';
import { useDispatch } from 'react-redux';
import { removeModal } from 'Redux/modules/modal/actions';
import { Modal } from 'semantic-ui-react';

const PreviewImage = ({ data, id }) => {
  const dispatch = useDispatch();
  const onClose = () => {
    dispatch(removeModal(id));
  };
  return (
    <Modal
      onClose={onClose}
      open
      closeIcon
      closeOnDimmerClick={data.closeOnDimmerClick ?? true}
      style={{ width: 'fit-content', minWidth: '300px' }}>
      <PrivateImage style={{ maxWidth: '100%' }} src={data.content} alt="preview" />
    </Modal>
  );
};

export default PreviewImage;
